import { QuoteBindingRequestParams, QuoteBindingPostResponse } from '@lio/api-types';
import { QuoteBinding } from '@models/quoteBinding';
import { quoteBindingQueryKey } from '@services/quotes/quoteBinding/keys';
import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useCreateQuoteBinding = () => {
  const client = useClient();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: async ({ quoteId, ...requestBody }: QuoteBindingRequestParams) => {
      const data = await client
        .post(`quote/${quoteId}/binding`, {
          json: requestBody,
          timeout: 30000,
        })
        .json<QuoteBindingPostResponse>();
      return data;
    },
    onSuccess: (data: any, variables) => {
      data?.items?.forEach((quote: QuoteBinding) => {
        queryClient.invalidateQueries({
          queryKey: quoteBindingQueryKey.get(quote.quoteId),
        });
      });

      queryClient.invalidateQueries({
        queryKey: ['quote', { quoteId: variables.quoteId }],
      });
    },
  });
  return mutation;
};
